import { Box, BoxProps, Text } from '@chakra-ui/react';
import React from 'react';
import { ShopProductContentType } from 'services/shops/interface';
import { ReactComponent as GraduationCap } from '../../Assets/images/icons/graudation-cap.svg';
import { B2B_WORKSHOP_CONTENT_TYPES } from './B2BWorkshop/constants';
import { WORKSHOP_TYPES_ENUMS } from './common/workshopTypes';

const {
  WORKSHOP,
  WORKSHOP_RECORDING,
  B2B_WORKSHOP_PROMO
} = WORKSHOP_TYPES_ENUMS;

type WorkshopTagTypeBasedContentSchema = {
  [key: string]: {
    tagBgColor: string;
    text: string;
    hideCap?: boolean;
    contentTypes?: Record<ShopProductContentType, string>;
  };
};

const WorkshopTagTypeBasedContent: WorkshopTagTypeBasedContentSchema = {
  [WORKSHOP]: {
    tagBgColor: 'blue.400',
    text: 'WORKSHOP'
  },
  [WORKSHOP_RECORDING]: {
    tagBgColor: 'blue.400',
    text: 'ON-DEMAND'
  },
  [B2B_WORKSHOP_PROMO]: {
    tagBgColor: 'workplaceBlue.400',
    text: 'WORKSHOP',
    contentTypes: B2B_WORKSHOP_CONTENT_TYPES,
    hideCap: true
  }
};

interface WorkshopTagProps extends BoxProps {
  type?: string;
  contentType?: ShopProductContentType;
}

const WorkshopTag = ({ type, contentType, ...boxProps }: WorkshopTagProps) => {
  const tagContent = WorkshopTagTypeBasedContent[`${type}`];

  if (!tagContent) {
    return null;
  }

  const tagText =
    tagContent.contentTypes && contentType
      ? tagContent.contentTypes[contentType]
      : tagContent.text;

  return (
    <Box
      display="inline-flex"
      borderRadius="5px"
      bgColor={tagContent.tagBgColor}
      padding="4px 5px 3px 5px"
      alignItems="center"
      {...boxProps}
    >
      <Box marginRight="3px" marginTop="-2px" hidden={tagContent.hideCap}>
        <GraduationCap width="10px" height="10px" fill="var(--neutral-0)" />
      </Box>
      <Text
        fontSize={['10px', '10px', '11px']}
        lineHeight={['14px', '14px', '15px']}
        fontWeight={700}
        color="neutral.0"
      >
        {tagText}
      </Text>
    </Box>
  );
};

export default WorkshopTag;
